import React from 'react';
import DropzonesContainer from '../../Componant/Bonus-Ui/Dropzones';

const Dropzones = () => {
  return (
    <div className='page-body'>
      <DropzonesContainer />
    </div>
  );
};

export default Dropzones;
